// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const CalculatorIndex    = lazy(() => import('../../views/calculator'))

const Calculator = [
  {
    path: '/calculator',
    element: <CalculatorIndex />
  }
]

export default Calculator
